import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { FlowInstructionHistory } from './FlowInstructionHistory';

const FlowInstructionHistoryBridge = react2angular(FlowInstructionHistory, [
  'instruction',
  'isMobile'
]);

export default FlowInstructionHistoryBridge;
